import maleBicepCurl from 'url:../../../../../../assets/images/exercises/bicep-curl.png';
import maleBurpees from 'url:../../../../../../assets/images/exercises/burpees.png';
import maleDumbbellLateralRaise from 'url:../../../../../../assets/images/exercises/dumbbell-lateral-raise.png';
import femaleBicepCurl from 'url:../../../../../../assets/images/exercises/female/bicep-curl.jpg';
import femaleBurpees from 'url:../../../../../../assets/images/exercises/female/burpees.jpg';
import femaleDumbbellLateralRaise from 'url:../../../../../../assets/images/exercises/female/dumbbell-lateral-raise.jpg';
import femaleHighKnees from 'url:../../../../../../assets/images/exercises/female/high-knees.jpg';
import femaleJabs from 'url:../../../../../../assets/images/exercises/female/jabs.jpg';
import femaleJumpingJacks from 'url:../../../../../../assets/images/exercises/female/jumping-jacks.jpg';
import femaleKneeToElbow from 'url:../../../../../../assets/images/exercises/female/knee-to-elbow.jpg';
import femaleWoodCutterLeftToRight from 'url:../../../../../../assets/images/exercises/female/male-wood-cutter-left-to-right.jpg';
import femaleWoodCutterRightToLeft from 'url:../../../../../../assets/images/exercises/female/male-wood-cutter-right-to-left.jpg';
import femalePlank from 'url:../../../../../../assets/images/exercises/female/plank.jpg';
import femalePressUp from 'url:../../../../../../assets/images/exercises/female/press-up.jpg';
import femaleShoulderPress from 'url:../../../../../../assets/images/exercises/female/shoulder-press.jpg';
import femaleSideLunge from 'url:../../../../../../assets/images/exercises/female/side-lunge.jpg';
import femaleSquat from 'url:../../../../../../assets/images/exercises/female/squat.jpg';
import femaleSquatJumps from 'url:../../../../../../assets/images/exercises/female/squat-jumps.jpg';
import femaleTricepDipsBench from 'url:../../../../../../assets/images/exercises/female/tricep-dips-bench.jpg';
import femaleUpperCut from 'url:../../../../../../assets/images/exercises/female/upper-cut.jpg';
import femaleWallSit from 'url:../../../../../../assets/images/exercises/female/wall-sit.jpg';
import maleHighKnees from 'url:../../../../../../assets/images/exercises/high-knees.png';
import maleJabs from 'url:../../../../../../assets/images/exercises/jabs.png';
import maleJumpingJacks from 'url:../../../../../../assets/images/exercises/jumping-jacks.png';
import maleKneeToElbow from 'url:../../../../../../assets/images/exercises/knee-to-elbow.png';
import maleWoodCutterLeftToRight from 'url:../../../../../../assets/images/exercises/male-wood-cutter-left-to-right.png';
import maleWoodCutterRightToLeft from 'url:../../../../../../assets/images/exercises/male-wood-cutter-right-to-left.png';
import malePlank from 'url:../../../../../../assets/images/exercises/plank.png';
import malePressUp from 'url:../../../../../../assets/images/exercises/press-up.png';
import maleShoulderPress from 'url:../../../../../../assets/images/exercises/shoulder-press.png';
import maleSideLunge from 'url:../../../../../../assets/images/exercises/side-lunge.png';
import maleSquat from 'url:../../../../../../assets/images/exercises/squat.png';
import maleSquatJumps from 'url:../../../../../../assets/images/exercises/squat-jumps.png';
import maleTricepDipsBench from 'url:../../../../../../assets/images/exercises/tricep-dips-bench.png';
import maleUpperCut from 'url:../../../../../../assets/images/exercises/upper-cut.png';
import maleWallSit from 'url:../../../../../../assets/images/exercises/wall-sit.png';

export const exerciseImagesMap: Record<string, { female: string; male: string }> = {
  'Bicep Curl': { female: femaleBicepCurl, male: maleBicepCurl },
  'Shoulder Press': { female: femaleShoulderPress, male: maleShoulderPress },
  'Press Up': { female: femalePressUp, male: malePressUp },
  'Side Lunge': { female: femaleSideLunge, male: maleSideLunge },
  'Jumping Jacks': { female: femaleJumpingJacks, male: maleJumpingJacks },
  Plank: { female: femalePlank, male: malePlank },
  'Knee To Elbow': { female: femaleKneeToElbow, male: maleKneeToElbow },
  'High Knees': { female: femaleHighKnees, male: maleHighKnees },
  Jabs: { female: femaleJabs, male: maleJabs },
  'Wood Cutter Left to Right': {
    female: femaleWoodCutterLeftToRight,
    male: maleWoodCutterLeftToRight,
  },
  'Wood Cutter Right to Left': {
    female: femaleWoodCutterRightToLeft,
    male: maleWoodCutterRightToLeft,
  },
  'Upper Cut': { female: femaleUpperCut, male: maleUpperCut },
  'Dumbbell Lateral Raise': { female: femaleDumbbellLateralRaise, male: maleDumbbellLateralRaise },
  'Squat Jumps': { female: femaleSquatJumps, male: maleSquatJumps },
  'Tricep Dips-Bench': { female: femaleTricepDipsBench, male: maleTricepDipsBench },
  'Wall Sit': { female: femaleWallSit, male: maleWallSit },
  Burpees: { female: femaleBurpees, male: maleBurpees }, // Female burpees doesn't exist
  Squat: { female: femaleSquat, male: maleSquat },
};
